import { select, put, call } from "redux-saga/effects";
import { fetchBrand7dSummarySuccess, fetchBrand7dSummaryFailure } from "../slice";
import { aggregateBrandEveryDaySummaryByBrand } from "../utils/brandEveryDayFromRows";
import { ScoreDailyAverageResponse } from "../response.types";
import { selectAuthAccountId } from "../../selectors/auth";
import { applySagaError } from "../../utils/saga";
import { scoresApi } from "../../../api/scores.api";



const BRAND_EVERY_DAY_SUMMARY_DAYS = 14;

export function* fetchBrand7dSummarySaga() {
  try {
    const userID: string | null = yield select(selectAuthAccountId);
    if (userID == null) return;

    const rows: ScoreDailyAverageResponse[] = yield call(scoresApi.fetchBrandScoreDays, {
      userID,
      days: BRAND_EVERY_DAY_SUMMARY_DAYS,
    });

    const summary = aggregateBrandEveryDaySummaryByBrand(rows);

    yield put(fetchBrand7dSummarySuccess(summary));
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "scores.fetchBrand7dSummary",
      failureAction: fetchBrand7dSummaryFailure,
    });
  }
}